import { DataSource, Layout, Repeater } from "@mcleod/components";

export abstract class AutogenLayoutTrailerContinuityWarnings extends Layout {
    repeaterTrailerWarnings: Repeater;
    sourceCheckTrailerContinuity: DataSource;
}
